import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
  FDPrimaryActionButton, FDDisplayText,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs } from 'Helpers/Testing';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import useMobileLayout from 'Hooks/useMobileLayout';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

const Layout = () => {
  const {
    resource,
    onSubmit,
  } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const isMobile = useMobileLayout();

  const handleClose = () => {
    clearModalCollection();
    refreshPageContentCollection();
  };

  const handleConfirm = () => {
    // If we are on the final step we need to just close the modal otherwise we need to submit
    if (resource.meta().action('POST')) {
      return onSubmit();
    }
    return handleClose();
  };

  return (
    <>
      <DialogContent>
        <Richtext
          Component={FDDisplayText}
          size={isMobile ? 'sm' : 'md'}
          value={resource.attr('title')}
          richtext={resource.metaField('title').attr('hint') === 'richtext'}
        />
        <FDStack spacing={3} direction={'column'} alignItems={'stretch'} paddingY={2}>
          <MetaControlField attr={'body'} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDPrimaryActionButton
          label="Let's go →"
          onClick={handleConfirm}
          {...dataAttrs('create-your-plan-continue-btn')}
        />
      </DialogActions>
    </>

  );
};
Layout.defaultProps = {
};
Layout.propTypes = {
};
export default Layout;
